import React, { useState, useEffect } from "react";
import "./Notifications.css";
import apiClient from "../../api";

const Notifications = () => {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [topic, setTopic] = useState("all_users");
  const [token, setToken] = useState("");
  const [targetType, setTargetType] = useState("topic"); // 'topic' or 'token'
  const [status, setStatus] = useState("");
  const [statusType, setStatusType] = useState("");
  const [sentNotification, setSentNotification] = useState(null);
  const [loading, setLoading] = useState(false);

  // Warn developer if the admin secret env var is not configured
  const adminSecret = import.meta.env.VITE_ADMIN_SECRET || '';

  const sendNotification = async () => {
    if (!title || !message) {
      setStatus("Please provide both title and message.");
      setStatusType("error");
      return;
    }

    if (!adminSecret) {
      setStatus("Configuration error: VITE_ADMIN_SECRET is not set in .env.local");
      setStatusType("error");
      return;
    }

    const target = targetType === "token"
      ? { token: token.trim() }
      : { topic };

    if (targetType === "token" && !token.trim()) {
      setStatus("Please enter a device FCM token.");
      setStatusType("error");
      return;
    }

    setLoading(true);
    setStatus("");
    setStatusType("");

    try {
      const response = await apiClient.post('/api/notifications/send-notification/', {
        title,
        message,
        ...target,
      }, {
        headers: {
          'X-Admin-Secret': adminSecret,
        }
      });

      if (response.data.error) {
        throw new Error(response.data.error);
      }

      setSentNotification({ title, message, target: targetType === "topic" ? `Topic: ${topic}` : `Token: ${token.slice(0, 20)}...` });
      setStatus("✅ Notification sent successfully!");
      setStatusType("success");
      setTitle("");
      setMessage("");
      setToken("");
    } catch (err) {
      console.error(err);
      setStatus(`❌ Error: ${err.response?.data?.error || err.message}`);
      setStatusType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="notifications-container">
      <h2 className="notifications-title">📢 Send Push Notification</h2>

      {!adminSecret && (
        <p className="status-message error" style={{ display: 'block', margin: '0 40px' }}>
          ⚠️ VITE_ADMIN_SECRET is not set in .env.local — notifications will be rejected by the backend.
        </p>
      )}

      <div className="notification-form">

        {/* Target Type Selector */}
        <div style={{ display: 'flex', gap: '12px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
            <input
              type="radio"
              name="targetType"
              value="topic"
              checked={targetType === "topic"}
              onChange={() => setTargetType("topic")}
            />
            Broadcast (all users)
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
            <input
              type="radio"
              name="targetType"
              value="token"
              checked={targetType === "token"}
              onChange={() => setTargetType("token")}
            />
            Specific device (token)
          </label>
        </div>

        {/* Topic or Token input */}
        {targetType === "topic" ? (
          <input
            type="text"
            placeholder="Topic (default: all_users)"
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
          />
        ) : (
          <input
            type="text"
            placeholder="Paste FCM device token here"
            value={token}
            onChange={(e) => setToken(e.target.value)}
          />
        )}

        <input
          type="text"
          placeholder="Notification Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <textarea
          placeholder="Notification Message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />

        <button onClick={sendNotification} disabled={loading}>
          {loading ? "Sending..." : "Send Notification"}
        </button>
      </div>

      {status && (
        <p className={`status-message ${statusType}`}>{status}</p>
      )}

      {sentNotification && (
        <div className="notification-preview">
          <h3>Just Sent:</h3>
          <h4>{sentNotification.title}</h4>
          <p>{sentNotification.message}</p>
          <small style={{ color: '#888' }}>{sentNotification.target}</small>
        </div>
      )}
    </div>
  );
};

export default Notifications;
